// extracted by mini-css-extract-plugin
export default {"favorite":"favourite_favorite__xtcbs"};